<svg-icon [ngClass]="classes" [applyCss]="true" src="/assets/icons/{{ svgName }}.svg"
    [svgStyle]="svgStyles"></svg-icon>